


































import { Vue, Component } from "vue-property-decorator";
import HIVEButton from "@/components/common/HIVEButton.vue";
import ChartsNav from "@/views/ChartsNav.vue";

@Component({
  components: {
    HIVEButton,
    ChartsNav,
  },
})
export default class HiveAppBar extends Vue {
  private showNav: boolean = false;

  private get user() {
    return this.$store.getters["authentication/getUser"];
  }

  /** signOut signs the user out of the application entirely */
  private signOut() {
    this.$store.dispatch("authentication/logout");
  }
}
